import { render, staticRenderFns } from "./ConfigSlideShowUpdate.vue?vue&type=template&id=1319daea&scoped=true&"
import script from "./ConfigSlideShowUpdate.vue?vue&type=script&lang=js&"
export * from "./ConfigSlideShowUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSlideShowUpdate.vue?vue&type=style&index=0&id=1319daea&scoped=true&lang=css&"
import style1 from "./ConfigSlideShowUpdate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1319daea",
  null
  
)

export default component.exports